<template>
    <div id="notification-queue">
        <TransitionGroup name="list-reverse">
            <component class="ma-4"
                       v-for="notification in pushNotifications"
                       :key="notification.id"
                       :is="notification.component"
                       :pushNotification="notification"
            />
        </TransitionGroup>
    </div>
</template>

<script>
import Message from "@/components/General/PushNotification/Message";
import SharedPage from "@/components/General/PushNotification/SharedPage";
import PhoneChecklist from "@/components/General/PushNotification/PhoneChecklist";
import PushNotification from "@/models/User/PushNotification";

export default {
    components: {
        Message,
        SharedPage,
        PhoneChecklist,
    },
    props: {
        position: {
            required: true,
            type: String,
        }
    },
    computed: {
        pushNotifications() {
            let notifications = PushNotification.query().where('position', this.position).get();

            for (let notification of notifications) {
                let foundEqual = notifications.filter(item => item.id !== notification.id && item.data.title === notification.data.title)
                if (foundEqual.length === 1) {
                    notification.$delete();
                    this.removeDuplicate(notifications, notification)
                }
            }

            return notifications
        }
    },
    methods: {
        removeDuplicate(array, notification) {
            const index = array.indexOf(notification);
            if (index > -1) {
                array.splice(index, 1)
            }

            return array;
        }
    },
    sockets: {
        'user:pushed-notification'(pushNotification) {
            (new PushNotification(pushNotification)).$save();
        }
    },
}
</script>
